import React from "react";
import { Form, Col } from "antd";
import { StyledInput } from "../styledComponent/styledElements";

const AddressFormField = ({ prefixName = "", requiredFields = [], form }) => {
  /**
   * @param {string} name - Field name
   * @returns {boolean} - Whether the field is required
   */
  const isFieldRequired = (name) => requiredFields.includes(name);

  return (
    <>
      <Col span={8}>
        <Form.Item
          label="Building"
          name={[prefixName, "building"]}
          rules={[
            {
              required: isFieldRequired("building"),
              message: "Building is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter building" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Area"
          name={[prefixName, "area"]}
          rules={[
            {
              required: isFieldRequired("area"),
              message: "Area is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter area" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Landmark"
          name={[prefixName, "landmark"]}
          rules={[
            {
              required: isFieldRequired("landmark"),
              message: "Landmark is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter landmark" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="City"
          name={[prefixName, "city"]}
          rules={[
            {
              required: isFieldRequired("city"),
              message: "City is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter city" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Pincode"
          name={[prefixName, "pincode"]}
          rules={[
            {
              required: isFieldRequired("pincode"),
              message: "Pincode is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter pincode" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Zipcode"
          name={[prefixName, "zipcode"]}
          rules={[
            {
              required: isFieldRequired("zipcode"),
              message: "Zipcode is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter zipcode" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Province"
          name={[prefixName, "province"]}
          rules={[
            {
              required: isFieldRequired("province"),
              message: "Province is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter province" width={"100%"} />
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item
          label="State"
          name={[prefixName, "state"]}
          rules={[
            {
              required: isFieldRequired("state"),
              message: "State is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter state" width={"100%"} />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Country"
          name={[prefixName, "country"]}
          rules={[
            {
              required: isFieldRequired("country"),
              message: "Country is required",
            },
          ]}
        >
          <StyledInput placeholder="Enter country" width={"100%"} />
        </Form.Item>
      </Col>
    </>
  );
};

export default AddressFormField;
